import { render } from "./BaseDialogFullscreen.vue?vue&type=template&id=1143f808&scoped=true"
import script from "./BaseDialogFullscreen.vue?vue&type=script&lang=js"
export * from "./BaseDialogFullscreen.vue?vue&type=script&lang=js"

import "./BaseDialogFullscreen.vue?vue&type=style&index=0&id=1143f808&scoped=true&lang=css"
import "./BaseDialogFullscreen.vue?vue&type=style&index=1&id=1143f808&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1143f808"]])

export default __exports__